
import { CensusFormProvider } from '../../census/components/provider/CensusFormProvider';
import OfcCreateTabs from './OfcCreateTabs';

export default function OfcCreatePage({ fromPark }: { fromPark?: boolean }) {
  return (
    <CensusFormProvider speciesFilter="ofc">
      <OfcCreateTabs fromPark={fromPark} />
    </CensusFormProvider>
  );
}